<p-confirmDialog
  #cd
  class="confirm-dialog"
  [visible]="visibleDialog"
  [closable]="false">
  <ng-template
    pTemplate="message"
    let-message>
    <div
      class="flex flex-col justify-center items-center p-5 rounded-md text-center"
      *ngIf="message">
      <p [innerHTML]="message.message"></p>
    </div>
  </ng-template>

  <ng-template
    pTemplate="footer"
    let-message>
    <div class="flex justify-center gap-2">
      <button
        *ngIf="showRejectButton"
        pButton
        [label]="rejectLabel"
        (click)="cd.reject()"
        class="bg-white border border-primary text-primary w-full font-wigrum-light h-12"></button>

      <button
        pButton
        [label]="acceptLabel"
        (click)="cd.accept()"
        [ngClass]="{ 'w-full': showRejectButton, 'w-auto px-6': !showRejectButton }"
        class="bg-primary text-white w-full h-12"></button>
    </div>
  </ng-template>
</p-confirmDialog>
